var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropzone',{ref:"pch",attrs:{"id":"dropZoneOrtic","duplicateCheck":true,"options":_vm.options},on:{"vdropzone-mounted":_vm.vMount,"vdropzone-success":_vm.vsuccess,"vdropzone-error":_vm.verror,"vdropzone-removed-file":_vm.vremoved}})
}
var staticRenderFns = []

export { render, staticRenderFns }